import React from "react"
import {
  Box,
  BoxProps,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/core"
import { useForm } from "react-hook-form"
import { Button } from "../Buttons"
import Body from "../typography/Body"
import Heading from "../typography/Heading"
import TextField from "../FormFields/TextField"
import ModalCloseButton from "../Buttons/ModalCloseButton"

type FormValues = {
  email: string,
  name: string,
  phone: string,
  location: string,
}

export type BackInStockButtonProps = Omit<BoxProps, "onSubmit"> & {
  variantId: string
  bikeTitle: string
  listName: string
  defaultEmail?: string | null
  defaultName?: string | null
  defaultPhone?: string | null
  defaultLocation?: string | null
  isLoading?: boolean
  onSubmit: (
    data: FormValues & { variantId: string; bikeTitle: string; listName: string; closeModal: VoidFunction }
  ) => void
}

export default function BackInStockButton({
  variantId,
  bikeTitle,
  listName,
  defaultEmail,
  defaultName,
  defaultPhone,
  defaultLocation,
  onSubmit,
  isLoading,
  ...props
}: BackInStockButtonProps) {
  const modal = useDisclosure()
  const { register, handleSubmit, formState } = useForm({
    mode: "onChange",
  })

  const onFormSubmit = (data: FormValues) => {
    onSubmit({ ...data, variantId, bikeTitle, listName, closeModal: modal.onClose })
  }

  return (
    <Box {...props}>
      <Button
        w="100%"
        onClick={modal.onOpen}
        className="QuizButtonWhite addToCart"
      >
        Notify me when available
      </Button>
      <Modal size="lg" isCentered isOpen={modal.isOpen} onClose={modal.onClose}>
        <ModalOverlay />
        <ModalContent
          borderRadius="0.5rem"
          px="1rem"
          py="2rem"
          textAlign="center"
        >
          <ModalCloseButton />
          <ModalHeader>
            <Heading as="h5" size="5">
              Notify me when available
            </Heading>
          </ModalHeader>
          <ModalBody>
            <Body mb="1.5rem">
              Get notified via email when this product is back in stock
            </Body>
            <Box as="form" mb="2rem" onSubmit={handleSubmit(onFormSubmit)}>
              <TextField
                ref={register({})}
                name="name"
                placeholder="Name"
                defaultValue={defaultName || undefined}
                mb="1rem"
              />
              <TextField
                ref={register({ required: true })}
                name="email"
                placeholder="Email"
                defaultValue={defaultEmail || undefined}
                mb="1rem"
              />
              <TextField
                ref={register({})}
                name="phone"
                placeholder="Phone"
                defaultValue={defaultPhone || undefined}
                mb="1rem"
              />
              <TextField
                ref={register({})}
                name="location"
                placeholder="Location"
                defaultValue={defaultLocation || undefined}
                mb="1rem"
              />
              <Button
                type="submit"
                w="100%"
                isDisabled={!formState.isValid}
                isLoading={isLoading}
              >
                Please notify me
              </Button>
            </Box>
            <Body size="sm" color="dawn">
              We will send you an email once the product becomes available. Your
              email address will not be shared with anyone else.
            </Body>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  )
}
